import React from 'react';

const LOADING = 'LOADING';
const RESPONSE_COMPLETE = 'RESPONSE_COMPLETE';
const ERROR = 'ERROR';

export const initialState = {
  result: null,
  loading: true,
  error: null,
};

export const fetchReducer = (state, action) => {
  if (action.type === LOADING) {
    return initialState;
  }

  if (action.type === RESPONSE_COMPLETE) {
    return {
      result: action.payload.response,
      loading: false,
      error: null,
    };
  }

  if (action.type === ERROR) {
    return {
      result: null,
      loading: false,
      error: action.payload.error,
    };
  }

  // If no action, we just return the state of the world as is
  return state;
};

/**
 * Custom hook to fetch data. It return an array with result, loading & error
 * @param {string} url
 * @param {{[method], [credentials], [headers], [body]}} options
 * @return {[*, boolean, *]}
 * @example const useFetchRecourses = (options) => {
 *   return useFetch(options.url, {method: 'post', body: options.body})
 * }
 * const [result, loading, error] = useFetchRecourses(options)
 */
const useFetch = (url, { method = 'get', credentials, headers, body } = {}) => {
  const [state, dispatch] = React.useReducer(fetchReducer, initialState);

  React.useEffect(() => {
    dispatch({ type: LOADING });

    // eslint-disable-next-line no-undef
    fetch(url, { method, credentials, headers, body })
      .then(response => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(data =>
        dispatch({
          type: RESPONSE_COMPLETE,
          payload: { response: data },
        }),
      )
      .catch(error => dispatch({ type: ERROR, payload: { error } }));
  }, [dispatch]);

  return [state.result, state.loading, state.error];
};

export default useFetch;
